import createRoute      from '@widesk-ui/tools/createRoute';
import PartnershipModel from '@models/website/PartnershipModel';

const route = createRoute.dashboardFromModel(
	PartnershipModel,
	'PartnershipDashboard',
	{
		pathPrefix: '/website_entertainments/:websiteEntertainmentId',
	}
);
export default route;
